<!-- INFO: Not currently used -->
<template>
  <div>
    <Card>
      <CardBody>
        <div class="flex justify-between items-start">
          <CardTitle :title="$t('ui.entities.proposal.label', 2)" />
          <Button
            :label="$t('ui.actions.new')"
            icon="plus"
            @click="$emit('open-proposal-builder')"
          />
        </div>
        <span class="text-secondary text-md">No proposals made</span>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <CardTitle title="Explore New" />
        <Carousel
          v-model:vehicles="newVehicles"
          v-model:favourites="favourites"
        />
      </CardBody>
      <CardBody>
        <CardTitle title="Explore Used" />
        <Carousel
          v-model:vehicles="usedVehicles"
          v-model:favourites="favourites"
        />
      </CardBody>
    </Card>
  </div>
</template>

<script setup lang="ts">
// composables
import { ref } from 'vue'
// components
import Card from '@/components/card/Card.vue'
import CardBody from '@/components/card/CardBody.vue'
import CardTitle from '@/components/card/CardTitle.vue'
import Button from '@/components/button/Button.vue'
import Carousel from '@/components/unique/switch/Carousel.vue'

interface Props {
  newVehicles: Array<Record<string, unknown>>
  usedVehicles: Array<Record<string, unknown>>
  favourites: number[]
}

const props = defineProps<Props>()

defineEmits<{
  'open-proposal-builder': []
  'update:newVehicles': [vehicles: Array<Record<string, unknown>>]
  'update:usedVehicles': [vehicles: Array<Record<string, unknown>>]
  'update:favourites': [favourites: number[]]
}>()

const newVehicles = ref(props.newVehicles)
const usedVehicles = ref(props.usedVehicles)
const favourites = ref(props.favourites)
</script>
